export const fields = [
  'PlanCYQ1',
  'PlanCYQ2',
  'PlanCYQ3',
  'PlanCYQ4',
  'PlanCY',
  'PlanNY',
  'PlanN2Y',
]
